module.exports = __webpack_public_path__ + "img/yuan4.4b35cb37.png";